import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import useApi from "../../../../utils/api";
import { useUser } from "../../../../utils/hooks/user";
import { useCompany } from "../../../../utils/hooks/company";
import { getErrorMessage } from "../../../../utils/helpers/errors";
import { preferenceQueryKeys } from "./usePreferenceQuery";

export const usePreferenceMutation = (entity: string, key: string, entityId?: string) => {
    const { t } = useTranslation();
    const user = useUser();
    const company = useCompany();
    const queryClient = useQueryClient();
    const { authPost } = useApi();

    return useMutation({
        mutationFn: (config: any) => {
            const id = entityId ?? (entity === "user" ? user?.id : company?.id);
            const url = `/preferencies/${entity}/${id}/${key}`;
            const data: any = { config, entity };
            if (entityId) data.entityId = entityId;
            return authPost(url, { data });
        },
        onSuccess: async () => {
            const id = entityId ?? (entity === "user" ? user?.id as string : company?.id as string);
            const queryKey = entity === "user"
                ? preferenceQueryKeys.user(id)
                : preferenceQueryKeys.company(id);
            await queryClient.invalidateQueries({ queryKey });
            toast.success(t("preferences-saved-successfully"));
        },
        onError: (err: any) => getErrorMessage(err, t),
    });
}
